// client/src/coms/voip/noiseGatePrefs.js

const KEY_THRESHOLD_DB = 'coms_noise_gate_threshold_db';

function safeStorageGet(k, fallback) {
  try {
    if (typeof window === 'undefined') return fallback;
    const v = window.localStorage.getItem(k);
    return v == null ? fallback : v;
  } catch {
    return fallback;
  }
}

function safeStorageSet(k, v) {
  try {
    if (typeof window === 'undefined') return;
    window.localStorage.setItem(k, String(v));
  } catch {}
}

export function getNoiseGateThresholdDb() {
  const raw = Number(safeStorageGet(KEY_THRESHOLD_DB, '-45'));
  if (!Number.isFinite(raw)) return -45;
  if (raw < -80) return -80;
  if (raw > -10) return -10;
  return raw;
}

export function setNoiseGateThresholdDb(db) {
  const n = Number(db);
  if (!Number.isFinite(n)) return;
  const clamped = n < -80 ? -80 : n > -10 ? -10 : n;
  safeStorageSet(KEY_THRESHOLD_DB, String(clamped));
}

export function emitNoiseGatePrefsChanged(payload) {
  try {
    if (typeof window === 'undefined') return;
    const detail = payload && typeof payload === 'object' ? payload : {};
    window.dispatchEvent(new CustomEvent('coms-noise-gate-changed', { detail }));
  } catch {
    try {
      window.dispatchEvent(new Event('coms-noise-gate-changed'));
    } catch {}
  }
}
